export default "__VITE_ASSET__Ca5Q7bO5__"